/*eslint no-unused-vars: ["error", { "args": "none" }]*/

import { createFromAlgoliaCredentials } from "vue-instantsearch";
import algoliasearch from "algoliasearch";
import { INIT_ALGOLIA_INDEX, SEARCH_ALGOLIA_STORE } from "../types";

const ALGOLIA_APP_ID = "2FPO1DGHJ9";
const ALGOLIA_API_KEY = "d254c4a4f898d493cf680b63e4ad1958";

export default {
  strict: false,
  state: {
    searchStore: createFromAlgoliaCredentials(
      ALGOLIA_APP_ID,
      ALGOLIA_API_KEY
    ).serialize(),
    searchClient: algoliasearch(ALGOLIA_APP_ID, ALGOLIA_API_KEY),
    indices: {},
  },
  getters: {},
  mutations: {
    [INIT_ALGOLIA_INDEX]: (state, payload) => {
      if (!state.indices[payload]) {
        state.indices[payload] = state.searchClient.initIndex(payload);
      }
    },
  },
  actions: {
    [SEARCH_ALGOLIA_STORE]: ({ commit, state }, { index, query }) => {
      return new Promise((resolve, reject) => {
        state.indices[index].search(query, (err, content) => {
          if (err) reject(err);
          resolve(content);
        });
      });
    },
  },
};
